<script>
  let logoRetina = 'images/logo@2x.png'
  let parallaxPercentage = 50
  let mousePosition = { x: 0, y: 0 }
  let imagePosition = { x: 0, y: 0 }
  let discordPromise = fetchData()

  async function fetchData() {
    const response = await fetch(
      'https://discordapp.com/api/guilds/553192263443021828/widget.json'
    )
    return await response.json()
  }

  function lerp(position, targetPosition) {
    return {
      x: position.x + (targetPosition.x - position.x) * 0.2,
      y: position.y + (targetPosition.y - position.y) * 0.2,
    }
  }

  function animate() {
    // only change position if the target is far enough
    if (
      Math.abs(mousePosition.x - imagePosition.x) >= 0.5 ||
      Math.abs(mousePosition.y - imagePosition.y) >= 0.5
    ) {
      imagePosition = lerp(imagePosition, mousePosition)
    }
    requestAnimationFrame(animate)
  }
  animate()
</script>

<style>
  .skew {
    background: #cd9b4b;
    width: 500px;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 0;
    opacity: 0;
    animation-name: skewAnim;
    animation-duration: .8s;
    animation-delay: 0.5s;
    animation-timing-function: cubic-bezier(0, 0, 0, 1);
    animation-fill-mode: forwards;
  }

  @media screen and (max-width: 480px) {
    .skew {
      display: none;
    }
  }


  section {
    height: 100vh;
    display: grid;
    grid-template-columns: 60% 40%;
    position: relative;
    z-index: 1;
  }

  @media screen and (max-width: 1024px) {
    section {
      grid-template-columns: 1fr;
    }
  }

  @media screen and (max-height: 812px) {
    section {
      grid-template-rows: 50% 50%;
    }
  }

  section .content {
    align-self: center;
    text-align: center;
  }

  section .content .button,
  section .content .button:visited {
    background: #f9bf61;
    color: white;
    text-decoration: none;
    display: inline-block;
    padding: 12px 50px;
    cursor: pointer;
    transition: background 0.2s;
  }

  @media screen and (max-width: 480px) {
    section .content .button {
      padding: 10px 50px;
    }
  }

  section .content .button:hover {
    background: #252424;
    transition: background 0.2s;
  }

  section .content .button span {
    display: block;
    color: white;
    font-size: 24px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    letter-spacing: 1px;
  }

  @media screen and (max-width: 480px) {
    section .content .button span {
      font-size: 18px;
    }
  }

  @media screen and (max-width: 1024px) {
    section .content {
      grid-row: 2;
    }
  }

  @media screen and (max-width: 480px) {
    section .content {
      align-self: normal;
    }
  }

  section .content h1 {
    font-size: 72px;
    color: white;
  }

  @media screen and (max-width: 480px) {
    section .content h1 {
      font-size: 32px;
    }
  }

  section .content h1 span {
    color: #f9bf61;
  }

  section img {
    max-width: 100%;
    margin: 0 auto;
    align-self: center;
    opacity: 0;
    animation-name: fadeInLogo;
    animation-duration: 0.6s;
    animation-delay: 0.5s;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
  }

  @media screen and (min-width: 1440px) {
    section img {
      max-width: 500px;
      width: 100%;
    }
  }

  @media screen and (max-width: 480px) {
    section img {
      max-width: 300px;
    }
  }

  ul.discord-info {
    margin: 20px auto 0;
    padding: 0;
    list-style-type: none;
    width: fit-content;
    text-align: center;
  }

  ul.discord-info li {
    color: white;
    font-size: 18px;
    padding-left: 25px;
    position: relative;
  }

  ul.discord-info li:before {
    background: green;
    content: '';
    width: 12px;
    height: 12px;
    display: block;
    position: absolute;
    left: 0;
    top: 6px;
    border-radius: 50%;
  }

  @keyframes fadeInLogo {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes skewAnim {
    from {
      width: calc(100vw * 2);
      transform: translateX(-200%);
    }
    to {
      transform: skew(-35deg) translateX(-50%);
      opacity: 1;
    }
  }
</style>

<svelte:window
  on:mousemove={e => (mousePosition = { x: -e.clientX / parallaxPercentage, y: -e.clientY / parallaxPercentage })} />

<svelte:head>
  <title>#Executed - Join now!</title>
</svelte:head>

<div class="skew" />

<section>
  <div class="content">
    <h1>
      A
      <span>New Home</span>
      <br />
      For All Gamers
    </h1>
    {#await discordPromise then data}
      <a href={data.instant_invite} class="button">
        <span>Join</span>
      </a>

      <ul class="discord-info">
        <li>{data.members.length} members online</li>
      </ul>
    {/await}
  </div>

  <img
    src={logoRetina}
    alt="#Executed!"
    style="transform: translate({imagePosition.x}px, {imagePosition.y}px)" />
</section>
